import React, { forwardRef, useLayoutEffect, useRef } from 'react';

import i18n from '@components/i18n/i18n';
import styles from './Message.module.scss';

// eslint-disable-next-line react/display-name
const Message = forwardRef(({ dispatch }, ref) => {
  // refs & vars
  const container = useRef(null),
    eyebrow = useRef(null),
    title = useRef(null),
    description = useRef(null),
    cta = useRef(null),
    cta2 = useRef(null),
    image = useRef(null),
    { visibility, content, style } = ref;
  const dir = i18n.dir();
  const classList = [styles.show, styles.zIndex, styles[style]];

  // handlers/helpers
  const updateInnerHTML = (e, n, a) => {
    e.current && (e.current[a] = content[n]);
  };
  const updateClasses = (c, t) => {
    const ccc = container.current?.classList;
    if (ccc) t ? ccc.add(...c) : ccc.remove(...c);
  };
  const updateContent = () => {
    updateInnerHTML(eyebrow, 'eyebrow', 'innerHTML');
    updateInnerHTML(title, 'title', 'innerHTML');
    updateInnerHTML(description, 'description', 'innerHTML');
    updateInnerHTML(cta, 'cta', 'innerHTML');
    updateInnerHTML(cta, 'link', 'href');
    updateInnerHTML(cta2, 'cta2', 'innerHTML');
    updateInnerHTML(cta2, 'link2', 'href');
    updateInnerHTML(image, 'image', 'src');
  };
  const showMessage = () => {
    updateContent();
    updateClasses(classList, 1);
  };
  const hideMessage = () => {
    updateClasses([styles.show], 0);
    setTimeout(() => updateClasses(classList, 0), 750);
  };
  const updateVisibility = () => {
    visibility ? showMessage() : hideMessage();
  };
  const closeMessageViaDispatch = () => {
    dispatch.message(false);
  };
  const checkForPopUpSuppression = () => {
    if (typeof window !== 'undefined') {
      const isPopUp = style == 'popUp';
      const isHomePage = window.location.pathname == '/';
      const isEnglish = i18n.language == 'en';
      const isSuppressed = localStorage.getItem('suppress_popUp') == 'true';
      const setItem = () => localStorage.setItem('suppress_popUp', 'true');
      if (isPopUp && !isEnglish) closeMessageViaDispatch();
      else if (isPopUp && isSuppressed) closeMessageViaDispatch();
      else if (!isSuppressed && isHomePage && isEnglish)
        setTimeout(() => setItem(), 1500);
    }
  };

  // effects -- these run on page load
  useLayoutEffect(() => {
    updateVisibility();
  }, [visibility]);

  checkForPopUpSuppression();

  //
  return (
    <div className={[styles.Message, styles[dir]].join(' ')} ref={container}>
      <div className={styles.overlay} onClick={closeMessageViaDispatch}></div>
      <div className={styles.container}>
        <button className={styles.close} onClick={closeMessageViaDispatch}>
          Close
        </button>
        <div className={styles.content}>
          <div className={styles.text}>
            {content.eyebrow && <p ref={eyebrow} className={styles.eyebrow} />}
            {content.title && <h2 ref={title} />}
            {content.description && <p ref={description} />}
            {content.cta && <a ref={cta} />}
            {content.cta2 && <a ref={cta2} />}
          </div>
          {content.image && (
            <div className={styles.visual}>
              <img ref={image} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default Message;
